export default {
  namespaced: true,
  state: {
    unreadCount: 0,
  },
  mutations: {
    SET_UNREAD(state, count) {
      state.unreadCount = count
    },
  },
  getters: {
    unreadCount: s => s.unreadCount,
  },
}
